import { Controller } from "@hotwired/stimulus"

// The farmer's offer form (docs/FEATURE-RFQ.md 9.5), Upwork-style terms:
// as the price or quantity changes, show the money live - "10 kg x 4.20 =
// 42.00 every week" - and how the price sits against the buyer's target.
export default class extends Controller {
  static targets = ["price", "quantity", "total", "frequencyLabel", "targetBadge"]
  static values = {
    currency: String,
    frequencies: Object,      // { one_time: "One time", weekly: "Every week", ... }
    targetCents: Number,      // 0 = buyer gave no target
    underTargetText: String,
    overTargetText: String
  }

  connect() { this.update() }

  update() {
    const price = parseFloat(this.priceTarget.value) || 0
    const qty = parseFloat(this.quantityTarget.value) || 0
    const total = price * qty

    if (this.hasTotalTarget) {
      this.totalTarget.textContent = total > 0
        ? `${qty} × ${this.currencyValue}${price.toFixed(2)} = ${this.currencyValue}${total.toFixed(2)}`
        : "—"
    }

    if (this.hasTargetBadgeTarget && this.targetCentsValue > 0 && price > 0) {
      const under = price * 100 <= this.targetCentsValue
      this.targetBadgeTarget.textContent = under ? this.underTargetTextValue : this.overTargetTextValue
      this.targetBadgeTarget.className = under
        ? "inline-block px-2 py-0.5 rounded-full bg-accent-green text-white text-xs font-medium"
        : "inline-block px-2 py-0.5 rounded-full bg-accent-yellow text-text-primary text-xs font-medium"
    } else if (this.hasTargetBadgeTarget) {
      this.targetBadgeTarget.textContent = ""
      this.targetBadgeTarget.className = ""
    }
  }

  frequencyChanged(event) {
    if (this.hasFrequencyLabelTarget) {
      this.frequencyLabelTarget.textContent = this.frequenciesValue[event.target.value] || ""
    }
  }
}
